import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';
import { isSelectionValid } from '../utils/is-selection-valid';

type Props = Omit<ComponentProps<typeof AudienceTray.SharedFooter>, 'children'>;

export const ListsViewFooter = (props: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { closeTray, mode, trackingIdPrefix, upsertAudience, selectedListIds, initialListIds } = useAudienceTray();

  const isDisabled =
    mode === 'lists-create-from-lists' ||
    mode === 'lists-create-from-recipients' ||
    mode === 'lists-create-from-upload' ||
    mode === 'lists-rename-list';

  return (
    <AudienceTray.SharedFooter {...props}>
      <Button
        variant='secondary'
        size='large'
        onClick={closeTray}
        disabled={isDisabled}
        trackingId={`${trackingIdPrefix}-lists-close-btn`}
      >
        {t('Close')}
      </Button>
      <Button
        size='large'
        disabled={isDisabled || !isSelectionValid(selectedListIds, initialListIds)}
        onClick={upsertAudience}
        trackingId={`${trackingIdPrefix}-apply-lists-btn`}
      >
        {t('Apply List', { count: selectedListIds.length })}
      </Button>
    </AudienceTray.SharedFooter>
  );
};
